module.exports = __webpack_public_path__ + "Starred-items.4f87023b2dcd7f4b28a1.svg";


//////////////////
// WEBPACK FOOTER
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/assets/modules/dummy-assets/common/img/icon/svg_icon/Starred-items.svg
// module id = ../../../../../src/assets/modules/dummy-assets/common/img/icon/svg_icon/Starred-items.svg
// module chunks = styles